export default __webpack_public_path__ + "static/media/video_instagram_stories.54939123.mp4";